import { lazy } from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'

const 
      Noticias = lazy(() => import('../../../views/NoticiasPublic/index')),
      NoticiasParis = lazy(() => import('../../../views/NoticiasParis2024')),
      NoticiasAyachucho = lazy(() => import('../../../views/NoticiasAyacucho2024')),
      NoticiasChengdu = lazy(() => import('../../../views/NoticiasChengdu2025/index')),
      NoticiasLima2025 = lazy(() => import('../../../views/NoticiasAyacuchoLima2025/index')),
      NoticiasJCA = lazy(() => import('../../../views/NoticiasJCA2025/index')),
      NoticiasASU2025 = lazy(() => import('../../../views/NoticiasASU2025/index')),
      DetalleNoticias = lazy(() => import('../../../views/NoticiasPublic/DetalleMicroCapsulas')),
      DetalleNoticisParis = lazy(() => import('../../../views/NoticiasParis2024/DetalleMicroCapsulas')),
      DetalleNoticiasAyachucho = lazy(() => import('../../../views/NoticiasAyacucho2024/DetalleMicroCapsulas')),
      DetalleNoticiasChengdu = lazy(() => import('../../../views/NoticiasChengdu2025/DetalleMicroCapsulas')),
      DetalleNoticiasLima2025 = lazy(() => import('../../../views/NoticiasAyacuchoLima2025/DetalleMicroCapsulas')),
      DetalleNoticiasJCA = lazy(() => import('../../../views/NoticiasJCA2025/DetalleMicroCapsulas')),
      DetalleNoticiasASU2025 = lazy(() => import('../../../views/NoticiasASU2025/DetalleMicroCapsulas'));



const Index = (props: any) =>{
  return (
    <Switch>
      <Route path={`${props.match.path}/public/:code`} component={DetalleNoticias} />
      <Route path={`${props.match.path}/public`} component={Noticias} />
      <Route path={`${props.match.path}/juegos-olimpicos-paris/:code`} component={DetalleNoticisParis} />
      <Route path={`${props.match.path}/juegos-olimpicos-paris`} component={NoticiasParis} />
      <Route path={`${props.match.path}/juegos-bolivarianos-ayacucho/:code`} component={DetalleNoticiasAyachucho} />
      <Route path={`${props.match.path}/juegos-bolivarianos-ayacucho`} component={NoticiasAyachucho} />
      <Route path={`${props.match.path}/world-games-chengdu-2025/:code`} component={DetalleNoticiasChengdu} />
      <Route path={`${props.match.path}/world-games-chengdu-2025`} component={NoticiasChengdu} />
      <Route path={`${props.match.path}/juegos-bolivarianos-ayacucho-lima-2025/:code`} component={DetalleNoticiasLima2025} />
      <Route path={`${props.match.path}/juegos-bolivarianos-ayacucho-lima-2025`} component={NoticiasLima2025} />
      <Route path={`${props.match.path}/juegos-centroamericanos-y-del-caribe-2025/:code`} component={DetalleNoticiasJCA} />
      <Route path={`${props.match.path}/juegos-centroamericanos-y-del-caribe-2025`} component={NoticiasJCA} />
      <Route path={`${props.match.path}/juegos-panamericanos-asuncion-2025/:code`} component={DetalleNoticiasASU2025} />
      <Route path={`${props.match.path}/juegos-panamericanos-asuncion-2025`} component={NoticiasASU2025} />

      <Redirect to='/error/404' />
    </Switch>
  )
}

export default Index
